module.exports = __webpack_public_path__ + "img/3. Person Centred Care 2.7d638438.png";